// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PQKBQF4mh4ss0v {
  width: calc(100% - 64px);
  max-width: 1250px;
  height: 1px;
  margin: auto;
  padding: 0;
  border: 0;
  background-color: var(--ds-border, #091e4224);
}
.FqLM8c7yEQePNP {
  background: var(--ds-surface, #ffffff);
}
.L4GpBleHd9zGyb {
  position: relative;
  max-width: 850px;
  margin: 0 auto;
  padding: 16px 32px;
}
.L4GpBleHd9zGyb.dq9g00f3cHbLtc {
  max-width: 1250px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"horizontalRule": `PQKBQF4mh4ss0v`,
	"mainColumn": `FqLM8c7yEQePNP`,
	"mainColumnInner": `L4GpBleHd9zGyb`,
	"fullWidth": `dq9g00f3cHbLtc`
};
export default ___CSS_LOADER_EXPORT___;
